import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Manager } from 'src/app/model/Manager';
import { Roles } from 'src/app/model/Roles';
import { Gender } from 'src/app/model/gender';
import { UtilisateursService } from '../../services/utilisateurs.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css'],
})
export class CreateUserComponent implements OnInit {
  cities!: any[];
  genders!: any[];
  roles!: Roles[];
  profils!: any[];
  notification!: boolean;
  createUserForm!: FormGroup;
  error!: boolean;
  errorCountExist!: boolean;
  email!: string;
  valid!: boolean;
  listpartenairebenin: any[] = [];
  selectedCertificates: number[] = [];

  readonly AVAILABLE_COUNTRIES: { id: number; name: string }[] = [
    // id pays et name sur la base de données
    { id: 287, name: 'Sénégal' },
    { id: 462, name: 'Bénin' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private authService: UtilisateursService,
    private router: Router,
    public spinner: SpinnerServiceService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getListpartenaireBenin();
    this.listRoles();

    this.createUserForm
      .get('selectedProfil')
      ?.valueChanges.subscribe((selectedRole) => {
        const structureControl = this.createUserForm.get('structure');
        if (selectedRole?.roleName.includes === 'benin') {
          structureControl?.setValidators([Validators.required]);
        } else {
          structureControl?.clearValidators();
          structureControl?.setValue('');
        }
        structureControl?.updateValueAndValidity();
      });

    this.genders = Gender.List;
  }

  get isResponsableBenin(): boolean {
    const roleName = this.createUserForm.get('selectedProfil')?.value?.roleName;
    return ['gestionnaire-fcc-benin', 'gestionnaire-finance-benin'].includes(
      roleName,
    );
  }

  initForm() {
    this.createUserForm = this.formBuilder.group({
      email: ['', Validators.required],
      lastname: ['', Validators.required],
      firstname: ['', Validators.required],
      selectedGender: ['', Validators.required],
      selectedProfil: ['', Validators.required],
      selectedCountry: ['', Validators.required],
      structure: [''],
    });
  }

  get structure() {
    return this.createUserForm.get('structure') as FormArray;
  }

  onSubmitForm() {
    window.scrollTo(0, 0);

    if (this.createUserForm.valid) {
      this.spinner.showSpinner();
      const formValue = this.createUserForm.value;
      const selectedRoleObject = formValue['selectedProfil'];
      const managerToCreate = new Manager(
        formValue['email'],
        formValue['lastname'],
        formValue['firstname'],
        { id: formValue['selectedGender'] },
        { id: 4 },
        {
          id: Number(selectedRoleObject.id),
          roleName: selectedRoleObject.roleName,
          libelle: selectedRoleObject.libelle,
        },
      );
      if (this.isResponsableBenin && formValue['structure']) {
        managerToCreate.structure = formValue['structure'];
      }
      managerToCreate.country = formValue['selectedCountry'];

      console.log('create user : ', managerToCreate);
      this.authService.createManager(managerToCreate).subscribe({
        next: (reponse) => {
          if (reponse) {
            if (reponse.status === 200) {
              this.notification = true;
              setTimeout(() => {
                this.notification = false;
                this.spinner.hideSpinner();
                this.router.navigate(['/dashboard/users/list']);
              }, 4000);
            } else if (reponse.countExist === true || reponse.status === 400) {
              this.email = formValue['email'];
              this.errorCountExist = true;
              setTimeout(() => {
                this.spinner.hideSpinner();
                this.errorCountExist = false;
              }, 4000);
            } else {
              this.error = true;
              setTimeout(() => {
                this.error = false;
                this.spinner.hideSpinner();
              }, 4000);
            }
          } else {
            this.error = true;
            setTimeout(() => {
              this.error = false;
              this.spinner.hideSpinner();
            }, 4000);
          }
        },
        error: (err) => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
            this.spinner.hideSpinner();
          }, 4000);
        },
      });
    } else {
      this.valid = true;

      setTimeout(() => {
        this.valid = false;
      }, 4000);
    }
  }

  listRoles() {
    this.authService.getListRoles().subscribe({
      next: (response) => {
        if (response) {
          this.roles = response;
          this.roles = this.roles.filter(
            (role: { roleName: string }) =>
              role.roleName != 'coursera_srudent' &&
              role.roleName != 'personal-company' &&
              role.roleName != 'ami' &&
              role.roleName != 'etudiant_stemd',
          );
        } else {
          console.log('error');
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getListpartenaireBenin() {
    this.authService.getPartenaireBenin().subscribe((data) => {
      console.log('list partnar :', data);
      this.listpartenairebenin = data;
    });
  }
}
